import React from "react";
import PropTypes from "prop-types";

const Img = ({
  img,
  title,
  url,
  posteddate,
  video,
  tags,
  hideDate,
  hideCategory,
  playButtonColor
}) => {
  return (
    <div className="cardDiv">
      <div className="Card">
        <div className="cardContent">
          <a
            href={url}
            className={
              playButtonColor && playButtonColor.toLowerCase().replace(" ", "-")
            }
          >
            {img && (
              <div className={"img-cnr" + (video && " video-cnr")}>
                {video && <span className="playbutton"></span>}
                <img className="cardImg" src={img} alt={title} />
              </div>
            )}
          </a>
          <div className="cardDescription">
            <a href={url}>
              {title && <h4 className="cardDescriptionTitle">{title}</h4>}
              {!hideDate && posteddate && (
                <div className="cardDescriptionDate">{posteddate}</div>
              )}
            </a>
            <div className="categories">
              {!hideCategory &&
                tags &&
                tags.length > 0 &&
                tags.map((tag, i) => (
                  <a key={i} href={tag.PageUrl}>
                    <span className="cardCategory" key={i}>
                      {tag.Title}
                    </span>
                  </a>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Img.propTypes = {
  img: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  posteddate: PropTypes.string,
  video: PropTypes.string,
  type: PropTypes.string,
  tags: PropTypes.array,
  hideDate: PropTypes.bool,
  hideCategory: PropTypes.bool,
  playButtonColor: PropTypes.string
};

export default Img;
